export const DEG_TO_RAD = Math.PI / 180
export const RAD_TO_DEG = 180 / Math.PI
export const FULL_CIRCLE_IN_RADIANS = 2 * Math.PI
